import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchContent, fetchArtworks, fetchPricing } from "@/lib/api";

const SiteDataContext = createContext(null);

export function SiteDataProvider({ children }) {
  const [content, setContent] = useState({});
  const [artworks, setArtworks] = useState([]);
  const [pricing, setPricing] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const [c, a, p] = await Promise.all([fetchContent(), fetchArtworks(), fetchPricing()]);
      setContent(c || {});
      setArtworks(a || []);
      setPricing(p || []);
    } catch (e) {
      // keep whatever we have; pages have static fallbacks
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const t = useCallback((key, fallback = "") => content[key] ?? fallback, [content]);

  return (
    <SiteDataContext.Provider value={{ content, artworks, pricing, loading, t, refetch: load }}>
      {children}
    </SiteDataContext.Provider>
  );
}

export const useSiteData = () => useContext(SiteDataContext);
